import {Component, Input, OnInit} from '@angular/core';
import {RequeteSummary} from '../../../entities/requete';

@Component({
    selector: 'jhi-numero-dossier',
    templateUrl: './numero-dossier.component.html',
    styleUrls: ['./numero-dossier.component.scss']
})
export class NumeroDossierComponent implements OnInit {

    @Input() dossier: RequeteSummary;

    constructor() {
    }

    ngOnInit(): void {

    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/home/mes-dossiers/numero-dossier/numero-dossier.component.ts